const state = {
  activities: [],
  isLoaded: false
}

export default state
